import { connect } from 'react-redux';
import { getCurrentUser, getCanEnableToggleMatureContent, getTierСount, getContentFilter } from '../../../../publicSession/selectors';
import { toggleMature, toggleTheme } from '../../../../publicSession/actions';
import { userLogoutButtonClicked } from '../../../redux/actions';
import { pushUserSettingsModal } from '../../../../Modals/redux/actionCreators';
const mapStateToProps = (state)=>({
        currentUser: getCurrentUser(state),
        canEnableMatureContent: getCanEnableToggleMatureContent(state),
        hasSubscriptions: getTierСount(state) > 0,
        contentFilter: getContentFilter(state)
    });
const mapDispatchToProps = {
    toggleTheme,
    toggleMature,
    onUserLogoutButtonClicked: userLogoutButtonClicked,
    pushUserSettingsModal
};
export default connect(mapStateToProps, mapDispatchToProps);
